import React from "react";
import useInterfaceContext from "../../components/providers/interface";
import ChatTestPageDesktop from "./components/ChatTestPageDesktop";
import ChatTestPageMobile from "./components/ChatTestPageMobile";

const ChatTestPage: React.FC = () => {
  const { isMobile } = useInterfaceContext();

  return isMobile ? <ChatTestPageMobile /> : <ChatTestPageDesktop />;
};

export default ChatTestPage;
